import Vue from 'vue';
import {
  Image as VanImage,
  Button,
  Field,
  Lazyload,
  Toast,
  Dialog,
  ImagePreview,
  Loading,
  Form,
  DatetimePicker,
  PullRefresh,
  List,
  Circle,
  Uploader,
  Swipe,
  SwipeItem,
  CountDown,
  Popover,
  Rate,
  Grid,
  GridItem,
  Progress,
  Notify,
  Popup,
  Tab,
  Tabs,
  Radio,
  ActionSheet,
  DropdownMenu,
  DropdownItem,
  Pagination,
  Icon,
  Sticky,
  Empty,
  Tag,
  Picker,
  Search,
  Row,
  Col,
  Collapse,
  CollapseItem,
  NavBar,
} from 'vant';

Vue.use(VanImage);
Vue.use(DatetimePicker);
Vue.use(Form);
Vue.use(NavBar);
Vue.use(Field);
Vue.use(Button);
Vue.use(Lazyload);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(ImagePreview);
Vue.use(Loading);
Vue.use(PullRefresh);
Vue.use(List);
Vue.use(Circle);
Vue.use(Uploader);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(CountDown);
Vue.use(Popover);
Vue.use(Rate);
Vue.use(Grid);
Vue.use(GridItem);
Vue.use(Progress);
Vue.use(Notify);
Vue.use(Popup);
Vue.use(Radio);
Vue.use(ActionSheet);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Pagination);
Vue.use(Icon);
Vue.use(Sticky);
Vue.use(Empty);
Vue.use(Tag);
Vue.use(Picker);
Vue.use(Search);
Vue.use(Row);
Vue.use(Col);
Vue.use(Collapse);
Vue.use(CollapseItem);

Vue.prototype.$imagePreview = ImagePreview;
Vue.prototype.$notify = Notify;
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;